module.exports = __webpack_public_path__ + "static/img/light-yellow.6bdea3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/light-yellow.png
// module id = t4Km
// module chunks = 1